import { DataService } from 'src/app/services/data.service';
import { Payment } from 'src/app/interfaces/transactions';
import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {

  payments: Payment[];

  totalItemsPerPage = 10;
  currentPage = 1;

  constructor(
    private data: DataService
  ) { }

  ngOnInit() {
    this.data.getAllPayments().subscribe((res) => {
      if(res && res.data){
        this.payments = res.data;
      }
    })
  }

}
